/** County/FSN Historical Irrigation Percentage (HIP) helpers — pure, no React. */

export const HISTORICAL_IRRIGATION_PERCENTAGE_DEFAULT = 0.7;

export const getDefaultHistoricalIrrigationPercentage = (
  historical_irrigation_percentage,
  doUseDefaultValue = true
) => {
  const DEFAULTVALUE = doUseDefaultValue ? HISTORICAL_IRRIGATION_PERCENTAGE_DEFAULT : null;
  if (historical_irrigation_percentage === 0) {
    return 0;
  } else {
    return historical_irrigation_percentage || DEFAULTVALUE;
  }
};

/** Share-weighted HIP across FSNs: Σ(base×share×hip) / Σ(base×share). Avoids county UI taking first/last row only. */
export const getShareWeightedHistoricalIrrigationPercentage = (baseAcres, doUseDefaultValue = true) => {
  if (!baseAcres?.length) {
    return getDefaultHistoricalIrrigationPercentage(null, doUseDefaultValue);
  }
  let owned = 0;
  let irrigatedOwned = 0;
  for (const ba of baseAcres) {
    const acres = Number(ba?.base_acreage) || 0;
    const share = ba?.share_percent == null || ba?.share_percent === "" ? 1 : Number(ba.share_percent);
    const ownedBase = acres * (Number.isFinite(share) ? share : 1);
    if (!(ownedBase > 0)) continue;
    const hip = getDefaultHistoricalIrrigationPercentage(ba?.historical_irrigation_percentage, doUseDefaultValue);
    if (hip == null) continue;
    owned += ownedBase;
    irrigatedOwned += ownedBase * hip;
  }
  if (!(owned > 0)) {
    return getDefaultHistoricalIrrigationPercentage(null, doUseDefaultValue);
  }
  return irrigatedOwned / owned;
};

/** Blank HIP (null / missing). Explicit 0 is a real value, not the 70% default. */
export const isHistoricalIrrigationPercentageEmpty = (value) => value == null || value === "";

/** True when any owned base acre is missing HIP, so the share-weighted figure uses the default. */
export const usesDefaultHistoricalIrrigationPercentage = (baseAcres) => {
  if (!baseAcres?.length) return false;
  return baseAcres.some((ba) => {
    const acres = Number(ba?.base_acreage) || 0;
    const share = ba?.share_percent == null || ba?.share_percent === "" ? 1 : Number(ba.share_percent);
    const ownedBase = acres * (Number.isFinite(share) ? share : 1);
    if (!(ownedBase > 0)) return false;
    return isHistoricalIrrigationPercentageEmpty(ba?.historical_irrigation_percentage);
  });
};
